import Mentions from "./mentions";

export default Mentions;